import React, { useContext, useEffect, useState } from "react";
import {
  View,
  Image,
  StyleSheet,
  TouchableOpacity,
  ImageSourcePropType,
  ScrollView} from "react-native";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { AuthContext } from "../../contexts/AuthContext";
import AsyncStorage from "@react-native-async-storage/async-storage";
import HomePageStyle from "./HomePageStyle";
import { UserContext } from "../../contexts/EmulateUserContext";
import { IUserRole } from "../../types/IUserRole";
import OverflowTooltipText from "../../components/OverflowTooltipText";
import { SafeAreaView } from "react-native-safe-area-context";
import { fonts } from "../../styles/theme";
import commonStyles from "../../styles/commonStyles";
import AppText from "../../components/AppText";
// import { Image as EImage } from "expo-image";

type RootStackParamList = {
  Investments: undefined;
  Properties: undefined;
  Payments: undefined;
  Tax: undefined;
  Agreements: undefined;
  EmulateUser: undefined;
  Profile: undefined;
  ProfilePage: undefined;
  EMI: undefined;
};

type HomePageProps = {
  closeHomepage: () => void;
};

type MenuItemProps = {
  title: string;
  icon: ImageSourcePropType;
  onPress: () => void;
};

interface ApiResponse {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  userRoleList: string[];
}

const HomePage: React.FC<HomePageProps> = ({ closeHomepage }) => {
  const { logout } = useContext(AuthContext);
  const [apiResponse, setApiResponse] = useState<ApiResponse | null>(null);
  const [userPicture, setUserPicture] = useState<ImageSourcePropType>();
  const { emulateUser, setEmulateUser } = useContext(UserContext);
  const [userInitials, setUserInitials] = useState<string | null>(null);

  const navigation =
    useNavigation<NativeStackNavigationProp<RootStackParamList>>();
  const [user, setUser] = useState<any>(null);

  const getUser = async () => {
    try {
      const userInfo = await AsyncStorage.getItem("user");

      if (userInfo !== null) {
        const user = JSON.parse(userInfo);
        setUser(user);
      } else {
        // setUser(null);
      }
    } catch (error) {
      // console.log("the erro is ", error);
    }
  };

  useEffect(() => {
    const fetchApiResponse = async () => {
      try {
        const storedResponse = await AsyncStorage.getItem("apiResponse");
        if (storedResponse) {
          setApiResponse(JSON.parse(storedResponse));
        }
      } catch (error) {
        console.error("Error fetching API response from storage:", error);
      }
    };

    fetchApiResponse();
    getUser();
    getUserPic();
  }, []);
  const getUserPic = async () => {
    try {
      const userInfo = await AsyncStorage.getItem("setUserProfile");
      const user = await AsyncStorage.getItem("user");
      const parsedUser = user ? JSON.parse(user) : null;

      if (userInfo === "local-defulat") {
        setUserPicture(require("../../../assets/adaptive-iconh.png"));
      } else if (userInfo) {
        setUserPicture({ uri: userInfo });
      } else if (parsedUser && parsedUser.firstName && parsedUser.lastName) {
        const initials =
          parsedUser.firstName.charAt(0).toUpperCase() +
          parsedUser.lastName.charAt(0).toUpperCase();
        setUserInitials(initials);
        setUserPicture(undefined);
      }
    } catch (error) {
      console.error("Error retrieving user data:", error);
    }
  };

  function onLogOut() {
    setEmulateUser(null);
    AsyncStorage.removeItem("emulatedUser");
    logout();
  }

  const handleNavigation = (screen: keyof RootStackParamList) => {
    navigation.navigate(screen);
    closeHomepage();
  };

  return (
    <SafeAreaView edges={["bottom", "left", "right"]} style={[HomePageStyle.container, HomePageStyle.zIndex3, commonStyles.screenBottomGap ]}>
      <View style={HomePageStyle.profileSection} testID="profile-section">
        {userPicture ? (
          <Image source={userPicture} style={styles.image} />
        ) : (
          <View style={styles.initialsAvatar}>
            <AppText style={styles.initialsText}>{userInitials}</AppText>
          </View>
        )}
        <View>
          <OverflowTooltipText
            text={user?.fullName}
            style={HomePageStyle.profileName}
          />
          <OverflowTooltipText
            text={user?.email}
            style={HomePageStyle.profileEmail}
          />
        </View>
      </View>

      <ScrollView
        contentContainerStyle={{
          paddingBottom: 90}}
        showsVerticalScrollIndicator={false}
      >
        <View style={HomePageStyle.menuSection}>
          <MenuItem
            title="Investment"
            icon={require("../../../assets/images/icons/investment.png")}
            onPress={() => handleNavigation("Investments")}
          />
          <MenuItem
            title="EMI"
            icon={require("../../../assets/images/icons/emi.png")}
            onPress={() => handleNavigation("EMI")}
          />
          <MenuItem
            title="Properties"
            icon={require("../../../assets/images/icons/land.png")}
            onPress={() => handleNavigation("Properties")}
          />
          <MenuItem
            title="Payments"
            icon={require("../../../assets/images/icons/payment.png")}
            onPress={() => handleNavigation("Payments")}
          />
          <MenuItem
            title="Tax Docs"
            icon={require("../../../assets/images/icons/tax.png")}
            onPress={() => handleNavigation("Tax")}
          />
          <MenuItem
            title="Agreements"
            icon={require("../../../assets/images/icons/agreement.png")}
            onPress={() => handleNavigation("Agreements")}
          />
          <MenuItem
            title="Profile"
            icon={require("../../../assets/images/icons/emulateUser.png")}
            onPress={() => handleNavigation("Profile")}
          />
          {apiResponse?.userRoleList?.length === 0 ||
          apiResponse?.userRoleList?.some((role) => role === "IN") ? null : (
            <MenuItem
              title="Emulate User"
              icon={require("../../../assets/images/icons/user.png")}
              onPress={() => handleNavigation("EmulateUser")}
            />
          )}

          <MenuItem
            title="Logout"
            icon={require("../../../assets/images/icons/logout.png")}
            onPress={onLogOut}
          />
        </View>
      </ScrollView>
      <View style={HomePageStyle.imageContainer}>
        <Image
          source={require("../../../assets/logo.png")}
          style={{
            width: 225,
            height: 50,
            tintColor: "#FFFFFF"}}
        />
      </View>
    </SafeAreaView>
  );
};

const MenuItem: React.FC<MenuItemProps> = ({ title, icon, onPress }) => (
  <TouchableOpacity onPress={onPress} style={[HomePageStyle.menuItem]}>
    <Image source={icon} style={[HomePageStyle.menuIcon]} />
    <AppText style={HomePageStyle.menuText}>{title} </AppText>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff"},
  image: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginBottom: 10},
  initialsAvatar: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: "#6C63FF",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 10},
  initialsText: {
    color: "#fff",
    //fontWeight: "bold",
    fontSize: 30,
    fontFamily: fonts.medium}});
export default HomePage;
